import { ILink } from 'constants/links'

export const ALWAYS_VISIBLE_ABRS = [
  '*',
  'operationGroups',
  'tasks',
  'configurations',
  'ops',
  'organogram',
]

export const normalizePath = (path: string) => (path.startsWith('/') ? path : '/' + path)

export const isPathActive = (target: string, pathname: string) => {
  const normalized = normalizePath(target)
  return pathname === normalized || pathname.startsWith(normalized + '/')
}

export const isModuleActive = (module: ILink, pathname: string) => {
  if (isPathActive(module.path, pathname)) {
    return true
  }
  return (module.list ?? []).some((sub) => isPathActive(sub.path, pathname))
}

export const canAccessAbr = (
  abr: string | undefined,
  permissionPolicy?: any,
) =>
  !abr ||
  ALWAYS_VISIBLE_ABRS.includes(abr) ||
  Boolean(permissionPolicy && permissionPolicy[abr])

export const filterLinksByPermission = (
  links: ILink[],
  permissionPolicy?: any,
) =>
  links
    .map((link) => {
      const filteredList = (link.list ?? []).filter((sub) => {
        if (sub.abr) return canAccessAbr(sub.abr, permissionPolicy)
        return canAccessAbr(link.abr, permissionPolicy)
      })

      const parentOk =
        canAccessAbr(link.abr, permissionPolicy) ||
        (link.list ?? []).some((sub) => sub.abr && canAccessAbr(sub.abr, permissionPolicy))

      if (!parentOk) return null

      if (!link.list) return link

      return {
        ...link,
        list: filteredList,
      }
    })
    .filter((link): link is ILink => Boolean(link))
    .filter((link) => !link.list || link.list.length > 0 || canAccessAbr(link.abr, permissionPolicy))
